import { render, staticRenderFns } from "./RouteConfigInfoList.vue?vue&type=template&id=12271fc3&scoped=true&"
import script from "./RouteConfigInfoList.vue?vue&type=script&lang=js&"
export * from "./RouteConfigInfoList.vue?vue&type=script&lang=js&"
import style0 from "./RouteConfigInfoList.vue?vue&type=style&index=0&id=12271fc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12271fc3",
  null
  
)

export default component.exports